export default "__VITE_PUBLIC_ASSET__9a74a0ac__"